export const resourceNames = {
  CART: 'CART',
  ORDER: 'ORDER',
  USER: 'USER',
  WISHLIST: 'WISHLIST',
};

export const unsubscriptionTypes = {
  FRIENDS: 'FRIENDS',
  LITTLE_FRIENDS: 'LITTLE_FRIENDS',
};

export const addToEventQueue = (event: string, data?: Record<string, any>) => {
  if (import.meta.client) {
    if (!window.auroraQueue) {
      window.auroraQueue = [];
    }

    // if auroraQueue length is 1 and the incoming object has the same event with data, dont push it again
    // page:loading:end initially gets called twice, so we need to prevent duplicates
    if (
      window.auroraQueue.length === 1 &&
      window.auroraQueue[0].event === event &&
      JSON.stringify(window.auroraQueue[0].data) === JSON.stringify(data)
    ) {
      return;
    }

    window.auroraQueue?.push({
      event,
      ...(data !== undefined && { data }),
    });
  }
};
